export default "__VITE_ASSET__CCGSb7Ka__"